import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface producteState {
	isLoading: boolean;
	productList: any;
	totalProduct: number;
	productDetail: any;
}

const initialState: producteState = {
	isLoading: false,
	productList: [],
	totalProduct: 0,
	productDetail: {}
};

const productSlice = createSlice({
	name: 'productSlice',
	initialState,
	reducers: {
		getAllproductInIt: state => {
			state.isLoading = true;
		},
		getAllproductSuccess: (state, action: PayloadAction<any>) => {
			const data = action.payload.data;
			state.isLoading = false;
			state.totalProduct = data.count;
			state.productList = [...data.productList];
		},
		getAllproductError: state => {
			state.isLoading = false;
			state.productList = [];
			state.totalProduct = 0;
		},
		deleteproductInit: state => {
			state.isLoading = true;
		},
		deleteproductSuccess: state => {
			// state.isLoading = false;
		},
		deleteproductError: state => {
			state.isLoading = false;
		},
		addproductInIt: state => {
			state.isLoading = true;
		},
		addproductSuccess: state => {
			state.isLoading = false;
		},
		addproductError: state => {
			state.isLoading = false;
		},
		getproductByIdInIt: state => {
			state.isLoading = true;
		},
		getproductByIdSuccess: (state, action: PayloadAction<any>) => {
			state.isLoading = false;
			state.productDetail = { ...action.payload.data.product };
		},
		getproductByIdError: state => {
			state.isLoading = false;
		},
		clearproductDetail: state => {
			state.productDetail = {};
		},
		updateproductStatusInit: state => {
			state.isLoading = true;
		},
		updateproductStatusSuccess: state => {
			state.isLoading = false;
		},
		updateproductStatusError: state => {
			state.isLoading = false;
		}
	}
});

export const {
	getAllproductError,
	getAllproductInIt,
	getAllproductSuccess,
	addproductError,
	addproductInIt,
	addproductSuccess,
	clearproductDetail,
	deleteproductError,
	deleteproductInit,
	deleteproductSuccess,
	getproductByIdInIt,
	getproductByIdError,
	getproductByIdSuccess,
	updateproductStatusError,
	updateproductStatusInit,
	updateproductStatusSuccess
} = productSlice.actions;

export default productSlice.reducer;
